import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { CSSForSelect, handleErrorToast } from '../../CustomFunctions';
import { AddwithWhiteCircle, DeleteDustbin, UpdatePencil } from '../../AllSvg';
import { Modal, ToastContainer } from 'react-bootstrap';
import Select from 'react-select';

const AddEmployeeRole = ({ getData, subCompanyId }) => {
    const [show, setShow] = useState(false)
    const handleShow = () => {
        getsubcompany();
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            role_name: "",
            sub_company: "",
        })
    }

    const [formData, setFormData] = useState({
        role_name: "",
        sub_company: "",
    });

    const [errors, seterrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        let requiredFields = [
            "role_name",
            "sub_company",
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        seterrors(newErrors);
        return Object.keys(newErrors).length === 0;

    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.post(`${BASE_URL}/siteproject/role/`, formData);
                if (res.status === 200) {
                    await getData();
                    handleClose();
                    toast.success("Data Uploaded Successfully!")
                    toast.dismiss(loadingToastId);
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getsubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }

    let getRoles = [];
    if (subCompanyId === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c") {
        getRoles = [
            { value: "AdminCIPL", label: "Admin" },
        ]
    }

    else {
        getRoles = [
            { value: "BD", label: "BD" },
            { value: "SiteManagement", label: "SiteManagement" },
            { value: "Admin", label: "Admin" },
            { value: "AuthorityEngineer", label: "AuthorityEngineer" },
            { value: "Account", label: "Account" },
            { value: "Hr", label: "HR" },
            { value: "Checker", label: "Checker" },
            { value: "DataEntryOperator", label: "Coordinator" },
            { value: "SiteEmployee", label: "SiteEmployee" },
            { value: "Employee", label: "HOEmployee" },
            { value: "ViewAccess", label: "ViewAccess" },
            { value: "CertificationAccess", label: "CertificationAccess" },
            { value: "CertificationAccessBd", label: "CertificationAccessBd" },
            { value: "CertificationAccessBd", label: "CertificationAccessBd" },
            { value: "MarketingDashboard", label: "MarketingDashboard" },

        ]
    }

    const roleOption = getRoles.sort((a, b) => b.label.localeCompare(a.label)).map((i) => ({
        value: i.value,
        label: i.label,
    }));

    const handleRoleOption = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                role_name: "",
            })

        } else {
            setFormData({
                ...formData,
                role_name: selectedOption.value,
            })
        }

        seterrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.role_name;
            return updatedErrors;
        });

    }
    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {


            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        seterrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }


    console.log("formData.sub_company")
    console.log(formData.sub_company)

    const subcompanyOption = subcompanyList.filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))
    const subcompanyOption2 = subcompanyList.filter(i => i.id === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    return (
        <>
            <button className='upload-svg' title='Add Role' onClick={handleShow}>
                <AddwithWhiteCircle /> Role
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Add Employee Role
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <label htmlFor="role_name">Select Role</label>
                                    <Select
                                        options={roleOption}
                                        onChange={handleRoleOption}
                                        value={roleOption.find(option => option.value === formData.role_name)}
                                        placeholder="Select Employee Role"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.role_name && (
                                    <div className="error-message font-size-text">{errors.role_name}</div>

                                )}
                                <div>

                                </div>
                            </div>
                            <div>
                                {/* <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? subcompanyOption : subcompanyOption2}
                                        onChange={handleCompanyChange}
                                        value={subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? subcompanyOption : subcompanyOption2.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div> */}
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={
                                            subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c"
                                                ? subcompanyOption
                                                : subcompanyOption2
                                        }
                                        onChange={handleCompanyChange}
                                        value={
                                            subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c"
                                                ? subcompanyOption.find(option => option.value === formData.sub_company)
                                                : subcompanyOption2.find(option => option.value === formData.sub_company)
                                        }
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>

                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                                <div>

                                </div>
                            </div>
                            <div className="button-models">
                                <button className="model-button   font-weight500   model-button-cancel" type="button" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}

const UpdateEmployeeRole = ({ getData, i, subCompanyId }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        getsubcompany();
        setFormData(i);
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({
        role_name: "",
        sub_company: "",

    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const newErrors = {};
        const requiredFields = [
            "role_name", "sub_company"
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.put(`${BASE_URL}/siteproject/roleupdate/${i.id}/`, formData);
                if (res.status === 200) {
                    await getData();
                    handleClose();
                    toast.success("Data Updated Successfully!")
                    toast.dismiss(loadingToastId);
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getsubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }


    let getRoles = [];
    if (subCompanyId === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c") {
        getRoles = [
            { value: "AdminCIPL", label: "Admin" },
        ]
    }

    else {
        getRoles = [
            { value: "BD", label: "BD" },
            { value: "SiteManagement", label: "SiteManagement" },
            { value: "Admin", label: "Admin" },
            { value: "AuthorityEngineer", label: "AuthorityEngineer" },
            { value: "Account", label: "Account" },
            { value: "Hr", label: "HR" },
            { value: "Checker", label: "Checker" },
            { value: "DataEntryOperator", label: "Coordinator" },
            { value: "SiteEmployee", label: "SiteEmployee" },
            { value: "Employee", label: "HOEmployee" },
            { value: "ViewAccess", label: "ViewAccess" },
            { value: "CertificationAccess", label: "CertificationAccess" },
            { value: "CertificationAccessBd", label: "CertificationAccessBd" },

        ]
    }

    const roleOption = getRoles.sort((a, b) => b.label.localeCompare(a.label)).map((i) => ({
        value: i.value,
        label: i.label,
    }));

    const handleRoleOption = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                role_name: "",
            })

        } else {
            setFormData({
                ...formData,
                role_name: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.role_name;
            return updatedErrors;
        });

    }
    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const subcompanyOption = subcompanyList.filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))
    const subcompanyOption2 = subcompanyList.filter(i => i.id === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    return (
        <>
            <button className='model-edit-button' title='Update Role' onClick={handleShow}>
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Update Employee Role
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={roleOption}
                                        onChange={handleRoleOption}
                                        value={roleOption.find(option => option.value === formData.role_name)}
                                        placeholder="Select Employee Role"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.role_name && (
                                    <div className="error-message font-size-text">{errors.role_name}</div>

                                )}
                                <div>

                                </div>
                            </div>
                            <div>
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? subcompanyOption : subcompanyOption2}
                                        onChange={handleCompanyChange}
                                        value={subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? subcompanyOption : subcompanyOption2.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                                <div>

                                </div>
                            </div>
                            <div className="button-models">
                                <button className="model-button   font-weight500   model-button-cancel" type="button" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )









}

const DeleteRole = ({ i, getData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Deleting: Please wait..."); //toast Logic
        setLoading(true);

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/roleupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getData();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Data Deleted Successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
            setLoading(false);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete role Data of {i.role_name}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export { AddEmployeeRole, UpdateEmployeeRole, DeleteRole }